import { apiClient } from './apiClient';

export interface EmissionFactor {
  id: string;
  fuelType: string;
  emissionFactor: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateEmissionFactorRequest {
  fuelType: string;
  emissionFactor: number;
  isActive: boolean;
}

export interface UpdateEmissionFactorRequest {
  fuelType?: string;
  emissionFactor?: number;
  isActive?: boolean;
}

export class EmissionFactorService {
  /**
   * Get all emission factors
   */
  static async getAll(): Promise<EmissionFactor[]> {
    return apiClient.get<EmissionFactor[]>('/emission-factors');
  }

  /**
   * Get only active emission factors
   */
  static async getActive(): Promise<EmissionFactor[]> {
    return apiClient.get<EmissionFactor[]>('/emission-factors/active');
  }

  /**
   * Get a specific emission factor by ID
   */
  static async getById(id: string): Promise<EmissionFactor> {
    return apiClient.get<EmissionFactor>(`/emission-factors/${id}`);
  }

  /**
   * Create a new emission factor
   */
  static async create(data: CreateEmissionFactorRequest): Promise<EmissionFactor> {
    return apiClient.post<EmissionFactor>('/emission-factors', data);
  }

  /**
   * Update an emission factor
   */
  static async update(id: string, data: UpdateEmissionFactorRequest): Promise<EmissionFactor> {
    return apiClient.put<EmissionFactor>(`/emission-factors/${id}`, data);
  }

  /**
   * Delete an emission factor
   */
  static async delete(id: string): Promise<void> {
    return apiClient.delete<void>(`/emission-factors/${id}`);
  }
}
